import { render, staticRenderFns } from "./PayerRelatedRecords.vue?vue&type=template&id=5c3a5ed1&scoped=true&"
import script from "./PayerRelatedRecords.vue?vue&type=script&lang=js&"
export * from "./PayerRelatedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a5ed1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
